import sanitizeHtml from 'sanitize-html';

const allowedTags = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'strong',
  'b',
  'em',
  'i',
  'mark',
  'small',
  'del',
  'ins',
  'sub',
  'sup',
  'br',
  'a'
];
const allowedAttributes = { a: ['href'] };

function sanitize(html: string): string {
  return sanitizeHtml(html, {
    allowedTags,
    allowedAttributes
  });
}

export default sanitize;
